// Define custom service providing the monthsShortNames and weekdays translations
import { Injectable } from '@angular/core';
import { MONTHS_FULL_NAMES, MONTHS_SHORT_NAMES } from '@constants/month-names';
import { WEEK_DAY_SHORT_NAMES } from '@constants/week-days-names';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomLocalizationAdapter extends NgbDatepickerI18n {
  constructor(private translation: TranslateService) {
    super();
  }


  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}.${date.month}.${date.year}`;
  }

  getMonthFullName(month: number, year?: number): string {
    return this.translation.instant(MONTHS_FULL_NAMES[month - 1]);
  }

  getMonthShortName(month: number, year?: number): string {
    return this.translation.instant(MONTHS_SHORT_NAMES[month - 1]);
  }

  getWeekdayLabel(weekday: number, width?: 'long' | 'short' | 'narrow'): string {
    return this.translation.instant(WEEK_DAY_SHORT_NAMES[weekday - 1]);
  }
}
